// The PQ fields that belong to the HOUSEHOLD record in Salesforce rather than
// to the Financial Profile.
//
// A PQ launched from a lead owns everything on the form: the lead is a
// prospect record the questionnaire itself created, so writing names and
// contact details back to it is the whole point. A PQ launched from a
// household (?householdId=, for an acquired firm's existing clients, who have
// no lead) is the opposite case. Operations maintains who those people are and
// how to reach them, the questionnaire does not, and a form filled in loosely
// ("Bob" over "Robert", a mobile number typed into the home phone) would
// overwrite a client record of record. Jimmy to Srivani, 2026-09-17: "if it's
// a household ID, I won't pass back any information that would change the
// household."
//
// One list drives two behaviours, which is what keeps them honest with each
// other: `toSalesforce` drops these from the payload in household mode, and
// the form renders them locked. Withholding without locking would leave an
// advisor typing into fields that silently never save, which is the failure
// this codebase has paid for more than once.
export const HOUSEHOLD_OWNED_FIELDS = {
  family: [
    'client1FirstName',
    'client1LastName',
    'client1Nickname',
    'client1DOB',
    'client1Age',
    'client2FirstName',
    'client2LastName',
    'client2Nickname',
    'client2DOB',
    'client2Age',
    'yearsMarried',
  ],
  contact: [
    'address1',
    'address2',
    'city',
    'state',
    'zip',
    'homePhone',
    'client1Cell',
    'client1Email',
    'client2Cell',
    'client2Email',
    'referredBy',
  ],
};

// Shown on a locked field so the advisor knows where the value comes from and
// why they cannot change it here.
export const HOUSEHOLD_LOCK_HINT = 'From the household record in Salesforce';

export function isHouseholdOwned(sectionId, key) {
  return (HOUSEHOLD_OWNED_FIELDS[sectionId] || []).includes(key);
}
